import { ComponentProps, memo } from 'react'
import { Accordion as MuiAccordion } from '@mui/material'
import { withErrorBoundary } from '@/components/Utils'
import { accordionStyles as styles } from './Accordion.style'

export interface AccordionProps extends ComponentProps<typeof MuiAccordion> {}

const Accordion = (props: AccordionProps) => {
  return <MuiAccordion sx={styles.accordionStyles} {...props} />
}

export default memo(withErrorBoundary(Accordion))
